import React from 'react';
import { Dialog, DialogContent, Grid } from '@material-ui/core';

import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { Button, Spinner } from '../../..';
import { StudioControlStyles } from '../../styles';

import { selectIsCalibratingAudioService } from '../../../../store/modules/studio/selectors';

const CalibratingModal = () => {
  const classes = StudioControlStyles();

  const isCalibrating = useSelector(selectIsCalibratingAudioService);

  const cancelHandler = () => {
    if (window.studioAudioService) {
      window.studioAudioService.cancelCalibrate();
    }
  };

  return (
    <Dialog
      open={isCalibrating}
      style={{ zIndex: 3147483646 }}
      PaperProps={{ className: classes.background }}
    >
      <DialogContent style={{ height: '100%' }}>
        <Grid container alignItems="center" justify="center" spacing={2}>
          <Grid item xs={12} sm={8} style={{ marginTop: 30 }}>
            <Spinner />
          </Grid>
          <Grid item xs={12} sm={8}>
            <p className={clsx(classes.text, classes.title, classes.center)}>
              Shhh, Calibrating in Progress
            </p>
          </Grid>
          <Grid item xs={12} sm={8}>
            <p className={clsx(classes.text, classes.center)}>
              Measuring environment noise, please do not speak for a moment.
            </p>
          </Grid>
          <Grid item container xs={12} sm={8} justify="center" style={{ marginBottom: 30 }}>
            <Grid item xs={8}>
              <Button onClick={cancelHandler} className={classes.button}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CalibratingModal;
